<template>
  <div>
    <loading v-show="showLoading"></loading>
    <div v-show="!showLoading" >

      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">

        <div class="invite-title">
          本月已成功邀请{{newInsertCount}}位
        </div>

        <div class="invite-content">

          <div class="invite-content-title">
            <div class="invite-title-desc">
              我的邀请人数
            </div>
            <div class="invite-title-num">
              {{listSize}}人
            </div>
          </div>

          <div class="invite-content-detail">

            <div class="invite-content-each">
              <div class="invite-content-each-title">
                用户名
              </div>
              <div class="invite-content-each-title">
                加入时间
              </div>
              <div class="invite-content-each-title">
                累计购买金额
              </div>
            </div>

            <div>
              <div class="invite-content-each" v-for="(invite,index) in inviteList" :key="index">
                <div class="invite-content-each-content">
                  {{invite.firstName}}
                </div>
                <div class="invite-content-each-content">
                  {{invite.fromDate|formatDate}}
                </div>
                <div class="invite-content-each-content">
                  ¥{{invite.totalGrandTotal}}
                </div>
              </div>
              <refresh @zj-load="loadMore" :lastPage='{total: !allLoaded, empty: inviteList.length,show:show}'>
              </refresh>
            </div>

          </div>

        </div>

      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { getDistributionCustomerList} from '@/router/api'
  import { NavBar, Image, Grid, Tabbar, Toast,PullRefresh} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import {setStore,getStore} from "../../../utils/mUtil";
  import refresh from '@/components/page/common/refresh.vue';

  export default {
    name: "distributionInvite",
    data(){
      return{
        showLoading:true,
        token:getStore("externalLoginKey"),
        inviteList:[],
        viewIndex:0,
        viewSize:10,
        allLoaded:false,
        show:false,
        listSize:0,
        isLoading:false,
        newInsertCount:0
      }
    },

    filters: {
      formatDate: function (value) {
        if(value!=null&&value!=''&&value!=undefined ){
          let date = new Date(value)
          let y = date.getFullYear()
          let MM = date.getMonth() + 1
          MM = MM < 10 ? ('0' + MM) : MM
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          let h = date.getHours();
          h = h < 10 ? ('0' + h) : h;
          let m = date.getMinutes();
          m = m < 10 ? ('0' + m) : m;
          let s = date.getSeconds();
          s = s < 10 ? ('0' + s) : s;
          return y + '-' + MM + '-' + d+'  '+h+':'+m
        }else{
          return ''
        }

      }
    },

    mounted(){
      this.initData()
    },
    components:{
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      loading,
      [PullRefresh.name]: PullRefresh,
      refresh
    },

    methods:{

      async initData() {
        this.getDetail()
      },

      getDetail:function () {
        let param = {
          externalLoginKey: this.token,
          viewIndex:this.viewIndex,
          viewSize:this.viewSize
        }
        getDistributionCustomerList(param)
          .then(res => {
            console.log(res);
            this.showLoading = false
            if(!res._ERROR_MESSAGE_){
              //成功
              this.listSize = res.listSize
              this.newInsertCount = res.newInsertCount
              if (res.resultList) {
                if (res.resultList.length == 0){
                  Toast("您还没有成功邀请客户");
                }

                if(res.viewIndex==0){
                  this.show = false
                }else{
                  this.show = true
                }

                if (res.resultList.length < res.viewSize) {
                  this.allLoaded = true
                } else {
                  this.allLoaded = false
                }
                var oldProductList = this.inviteList
                var newProductList = oldProductList.concat(res.resultList)
                this.inviteList = newProductList
              } else {
                Toast({message:"您还没有成功邀请客户"});
              }
            }else{
              Toast({message:res._ERROR_MESSAGE_})
            }
          })
          .catch(err => {
            this.showLoading = false
            console.log(err);
          });
      },

      //上拉加载
      loadMore() {
        if (!this.allLoaded) {
          this.viewIndex ++;
          this.getDetail()
        }
      },

      //下拉刷新
      onRefresh() {
        setTimeout(() => {
          this.inviteList = []
          this.getDetail()
          this.isLoading = false
        }, 1000);
      },

    }
  }

</script>

<style scoped>
  .invite-title{
    width:100%;
    text-align: center;
    height: 2rem;
    line-height: 2rem;
    font-size: 0.75rem;
    color:#666666;
  }

  .invite-content{
    width:21.473rem;
    margin: 0 auto;
  }
  .invite-content-title{
    width:100%;
    height: 3rem;
    line-height: 3rem;
    font-size: 0.875rem;
    color:#333;
    clear: both;
  }
  .invite-title-desc{
    display: inline-block;
    vertical-align: top;
    float: left;
  }
  .invite-title-num{
    float: right;
  }
  .invite-content-detail{
    width:100%;
    box-shadow: 0 0 0.625rem #ddd;
    border-radius: 0.5rem;
  }
  .invite-content-each{
    width:100%;
    border-bottom: 1px solid #E5E5E5;
    height: 2.78125rem;
    line-height: 2.78125rem;
  }
  .invite-content-each div{
    float: left;
    width:calc(100% / 3);
    text-align: center;
    max-height: 2.5rem;
    overflow: hidden;
  }
  .invite-content-each-content{
    font-size: 0.75rem;
    color:#666;
  }
  .invite-content-each-title{
    font-size: 0.8125rem;
    color:#333;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/mine/distributionInvite.vue